
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

console.log('Main script loaded');

try {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    console.log('Root element found');
    createRoot(rootElement).render(<App />);
  } else {
    console.error('Root element not found!');
  }
} catch (error) {
  console.error('Fatal error in main.tsx:', error);
  // Create a fallback UI if the app fails to load
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h1>Something went wrong</h1>
        <p>The application failed to load. Please check the console for more details.</p>
      </div>
    `;
  }
}
